import { RouteObject } from 'react-router-dom'
import { TrailerPage } from './trailer'
import { StoreTrailerDetailsPage } from './store-trailer-details/store-trailer-details'
import { TrailerSummaryTab } from './trailer-summary'
import { TrailerScheduleTab } from './trailer-schedule'
import { Navigate, useLocation } from 'react-router-dom'
import React, { FC } from 'react'
import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'
import { NonStore } from './NonStore'

// Factory to create a protected store-only route element, redirecting non-store back to /trailer preserving query
const makeStoreGuard = (StoreComponent: FC) => {
    const Guard: FC = () => {
        const { currentLocation } = useEssentials()
        const { search } = useLocation()
        if (!isStore(currentLocation)) {
            return <Navigate to={`/trailer${search}`} replace />
        }
        return <StoreComponent />
    }
    return Guard
}

const ProtectedTrailerSummaryRoute = makeStoreGuard(TrailerSummaryTab)
const ProtectedTrailerScheduleRoute = makeStoreGuard(TrailerScheduleTab)

// Root index handler: if store redirect to summary (preserving query); non-store -> NonStore
const TrailerRootRoute: React.FC = () => {
    const { currentLocation } = useEssentials()
    const { search } = useLocation()
    if (isStore(currentLocation)) {
        return <Navigate to={`/trailer/summary${search}`} replace />
    }
    return <NonStore />
}

export const TrailerRoute: RouteObject = {
    path: '/trailer',
    element: <TrailerPage />,
    children: [
        { index: true, element: <TrailerRootRoute /> },
        { path: 'summary', element: <ProtectedTrailerSummaryRoute /> },
        { path: 'schedule', element: <ProtectedTrailerScheduleRoute /> },
    ],
}

export const TrailerDetailRoute: RouteObject = {
    path: '/trailer/detail',
    element: <StoreTrailerDetailsPage />,
}
